// METIER

import {
    EmailSearchFilter,
    EmailSortBy,
} from "../../managers/mail/types/search";
import { logger } from "../logs/core";
import { LOGS } from "../logs/logConfig";

// Fonction pour construire la requête Graph API
export function buildEmailGraphQueryFromfilterObject(
    filter: EmailSearchFilter,
): string {
    let query = "/me";

    if (filter.folder !== undefined && filter.folder !== "") {
        query += `/mailFolders/${encodeURIComponent(filter.folder)}/messages`;
    } else {
        query += "/messages";
    }

    const params = new URLSearchParams({
        $select: "id,internetMessageId,sentDateTime,isRead,from,toRecipients",
    });

    logger.info(
        LOGS.Perfs,
        `!!! Graph searchText : ${filter.searchText?.join(" - ")}`,
    );
    if (filter.searchText !== undefined && filter.searchText.length > 0) {
        const searchQuery = filter.searchText
            .map((term) => `"${term}"`)
            .join(" AND ");
        params.append("$search", searchQuery);
    }

    // Filtrage par date
    if (filter.dateRange) {
        const filters: string[] = [];

        if (filter.dateRange.start) {
            const startDate =
                typeof filter.dateRange.start === "string"
                    ? new Date(filter.dateRange.start)
                    : filter.dateRange.start;
            filters.push(`sentDateTime ge ${startDate.toISOString()}`);
        }

        if (filter.dateRange.end) {
            const endDate =
                typeof filter.dateRange.end === "string"
                    ? new Date(filter.dateRange.end)
                    : filter.dateRange.end;
            filters.push(`sentDateTime le ${endDate.toISOString()}`);
        }

        if (filters.length > 0) {
            params.append("$filter", filters.join(" and "));
        }
    }

    // Tri
    if (filter.sortBy && filter.sortOrder) {
        const sortBy =
            filter.sortBy === EmailSortBy.DATE ? "sentDateTime" : filter.sortBy;

        params.append("$orderby", `${sortBy} ${filter.sortOrder}`);
    }

    params.append("$top", "1000");

    query = `${query}?${params.toString()}`;

    return query;
}

// Validation et conversion des dates
// let startDate: Date | null = null;
// let endDate: Date | null = null;

// if (filter.dateRange) {
//     if (typeof filter.dateRange.start === 'string') {
//         startDate = new Date(filter.dateRange.start);
//     } else if (filter.dateRange.start instanceof Date) {
//         startDate = filter.dateRange.start;
//     }

//     if (typeof filter.dateRange.end === 'string') {
//         endDate = new Date(filter.dateRange.end);
//     } else if (filter.dateRange.end instanceof Date) {
//         endDate = filter.dateRange.end;
//     }

//     // Vérification de la validité des dates
//     if (Number.isNaN(startDate!.getTime()) || Number.isNaN(endDate!.getTime())) {
//         throw new Error("Invalid date format in dateRange");
//     }
// }

// Définition de parties de filtre
// const filterParts: string[] = [];

// if (startDate && endDate) {
//     filterParts.push(`sentDateTime ge ${startDate.toISOString()} and sentDateTime le ${endDate.toISOString()}`);
// }

// if (filter.isUnread !== undefined) {
//     filterParts.push(`isRead eq ${!filter.isUnread}`);
// }

// if (filterParts.length > 0) {
//     query += `&$filter=${filterParts.join(' and ')}`;
// }

// query += `&$orderby=sentDateTime ${filter.sortOrder || 'desc'}`;
// Order by not allowed in search
// params.append('$orderby', `sentDateTime ${filter.sortOrder || 'desc'}`);

// query += '&$top=1000'; // Ajustez ce nombre selon vos besoins
// if(filter.top !== undefined){
//     params.append('$top', filter.top.toString());
// }
